// eslint-disable-next-line @typescript-eslint/naming-convention,@typescript-eslint/ban-types
export const Mixin = (...baseCtors: Function[]) => (derivedCtor: Function) => {
    baseCtors.forEach(baseCtor => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
            Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name));
        });
    });
};
